import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Button,
  Form,
  Input,
  Table
} from "reactstrap";

const AccountsTab = () => {
  const [loading, setLoading] = useState(false);

  return (
    <Container fluid>
      {/* <div className="d-flex justify-content-between align-items-center mb-2 mt-2">
        <h4 className="page-title">Collect Outstanding Balance</h4>
        <div className="text-muted">Account | Invoices | Payments</div>
      </div> */}

      <Row>
        {/* Left Column */}
        <Col md={9}>
          <Card>
            <CardBody>
              {/* Account Details */}
              <h5 className="mb-3">Account Details</h5>
              <Form>
                <Row>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label>Account holder</Label>
                      <Input type="text" placeholder="Enter account holder" />
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label>Account no.</Label>
                      <Input type="text" placeholder="Enter account no." />
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label>Account type</Label>
                      <Input type="select">
                        <option>Cash</option>
                        <option>Credit</option>
                      </Input>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label>Contact cellphone</Label>
                      <Input type="text" placeholder="Enter cellphone" />
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label>Contact email</Label>
                      <Input type="email" placeholder="Enter email" />
                    </div>
                  </Col>
                  <Col lg={4} className="d-flex flex-column justify-content-center">
                    <div>
                      <strong>Patient liable:</strong>{" "}
                      <span className="text-danger">R 1,500.00</span>
                    </div>
                    <div>
                      <strong>Medical aid liable:</strong> R 0.00
                    </div>
                    <div>
                      <strong>Account age:</strong> 0 - 30 days
                    </div>
                  </Col>
                </Row>
              </Form>

              {/* Account Members */}
              <h5 className="mt-4 mb-3">Account Members</h5>
              <Button color="success" size="sm" className="mb-2">
                + Add new member
              </Button>
              <Table bordered responsive>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Surname</th>
                    <th>Date of Birth</th>
                    <th>Dep. Code</th>
                    <th>Relation</th>
                    <th>Account Holder</th>
                    <th>Validation Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>MUSA</td>
                    <td>NGOETJANA</td>
                    <td>26/03/2012</td>
                    <td>-</td>
                    <td>Account holder</td>
                    <td>Yes</td>
                    <td>Not supported</td>
                  </tr>
                </tbody>
              </Table>

              {/* Bottom Buttons */}
              <div className="d-flex justify-content-end mt-3">
                <Button color="secondary" className="mx-1">
                  Re-allocate
                </Button>
                <Button color="danger" className="mx-1">
                  Discard
                </Button>
                <Button color="dark" className="mx-1">
                  Close
                </Button>
                <Button color="warning" className="mx-1">
                  Follow up
                </Button>
                <Button color="success" className="mx-1">
                  Collection complete
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>

        {/* Right Column - Sidebar Menu */}
        <Col md={3}>
          <Card>
            <CardBody>
              <div className="d-flex flex-column">
                {[
                  "Capture Invoice",
                  "Generate statement",
                  "Capture patient payment",
                  "Write off",
                  "Credit note",
                  "Unallocated credit",
                  "Debit note",
                  "Send SMS",
                  "Email statement",
                  "Notes",
                  "Delete account",
                  "Print account details"
                ].map((item, idx) => (
                  <Button
                    key={idx}
                    color="link"
                    className="text-start px-0 mb-2"
                  >
                    {item}
                  </Button>
                ))}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AccountsTab;
